module.exports = {
  "": "You must pick a goal before continuing",
  "domestic-1": "Increase the rate of reproduction by 20-40%",
  "domestic-2": "Develop land to convert 25% of unusable land into usable land",
  "domestic-3": "Increase food production by 20-40%",
  "domestic-4": "Increase education funding. Improves military, food production, and technology by 10%",
  "military-1": "Increase the quality of all soldiers by 20-40%, depending on their intelligence level",
  "military-2": "Increase readiness of military if you anticipate an attack, gain 100% defensive bonus",
  "military-3": "Increase defensive bonus of workers by 150%",
  "military-4": "Increase military efficiency by 30%",
  "technology-1": "Increase productivity of military goals by 25%",
  "technology-2": "Increase productivity of domestic goals by 25%",
  "technology-3": "Guarantee the success of your next espionage move",
  "technology-4": "Make double progress towards advancing to the next age",
  "shady-1": "Provokes an enemy to attack you with a lower military efficiency",
  "shady-2": "Provokes another enemy to attack your target (failure might "+
  "instead cause both enemies to attack you)",
  "shady-3": "If successful, target country will be vulnerable to attack for "+
  "the following age",
  "shady-4": "Lower the morale of a target country. They will suffer from "+
  "lower production, military efficiency, and technology. Failure will "+
  "result in a gain by the same proportion",
};



/*****************
 ** WEBPACK FOOTER
 ** ./game/views/constants.js
 ** module id = 10
 ** module chunks = 0
 **/